import { TableCell, TableHead, TableRow } from '@mui/material'

import { FloraTypography } from '@grupoboticario/flora-react'

import { SortArrows } from '@/icons/SortArrows'

import * as S from './TableHeader.styles'

const TableHeader = ({ columns = [], isSortable = true, onSort = () => {}, sort = { column: '', order: '' } }) => (
  <TableHead>
    <TableRow>
      {columns.map((column) => (
        <TableCell
          key={column.id}
          style={{
            minWidth: column.minWidth,
            textAlign: column.textAlign || 'left'
          }}
        >
          <div
            style={{
              display: 'grid',
              grid: `auto-flow / 1fr ${column.id === 'edit' ? 'auto' : '1fr'}`,
              alignItems: 'center'
            }}
          >
            <FloraTypography className="item" css={S.headerTextCss} fontSize="exceptionsRestricted">
              {column.label}
            </FloraTypography>
            {column.id === 'edit' ? null : (
              <button
                className="item"
                onClick={() => {
                  if (isSortable) {
                    onSort({
                      column: column.id,
                      order: sort.order === 'desc' ? 'asc' : 'desc'
                    })
                  }
                }}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  border: 'none',
                  background: 'none',
                  cursor: 'pointer'
                }}
              >
                {isSortable && <SortArrows />}
              </button>
            )}
          </div>
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
)

export default TableHeader
